module.exports = __webpack_public_path__ + "assets/intercom.e400df45.svg";